var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 51,
    viewBox: "0 0 57 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.10742,
    y: 1.02002,
    width: 42.75,
    height: 40.8,
    rx: 4,
    fill: "#FFD3D3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7944 34.7208C23.2473 34.578 21.7205 33.864 20.5398 32.6196C17.8526 29.784 17.8526 25.1328 20.5398 22.2972L24.998 17.6052C27.6851 14.7696 32.1026 14.7696 34.8101 17.6052C37.4973 20.4408 37.4973 25.092 34.8101 27.9276L32.5912 30.2736",
    stroke: "#007BFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3475 18.3193C41.8946 18.4621 43.4214 19.1761 44.6021 20.4205C47.2893 23.2561 47.2893 27.9073 44.6021 30.7429L40.1439 35.4349C37.4568 38.2705 33.0393 38.2705 30.3318 35.4349C27.6446 32.5993 27.6446 27.9481 30.3318 25.1125L32.5507 22.7665",
    stroke: "#007BFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4639 46.9201H38.6782C48.8567 46.9201 52.9282 42.8401 52.9282 32.6401V20.4001C52.9282 10.2001 48.8567 6.12012 38.6782 6.12012H26.4639C16.2853 6.12012 12.2139 10.2001 12.2139 20.4001V32.6401C12.2139 42.8401 16.2853 46.9201 26.4639 46.9201Z",
    stroke: "#007BFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLink);
export default __webpack_public_path__ + "static/media/IconLink.2345bab57d8517bebce9d69923fb5ec5.svg";
export { ForwardRef as ReactComponent };